import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type PostLoginService from 'tio-employee/services/post-login';
import type SessionService from 'tio-employee/services/session';

export default class PostLoginIndexRoute extends Route {
  @service declare postLogin: PostLoginService;
  @service declare router: RouterService;
  @service declare session: SessionService;

  async beforeModel() {
    this.postLogin.initializeFromSession();
    if (!this.postLogin.tempToken) {
      this.router.transitionTo('login');
      return;
    }

    await this.postLogin.refreshRequirements();
    const nextRoute = this.postLogin.nextRouteName;
    if (nextRoute) {
      this.router.transitionTo(nextRoute);
      return;
    }

    const accessToken = await this.postLogin.complete();
    await this.session.authenticate('authenticator:saml', { access_token: accessToken });
    this.postLogin.clear();
    this.router.transitionTo('authenticated');
  }
}
